// project specific js -- require JS jQuery Kickstart: requirejs(['jquery'], function ($) {})